@if (systemUpdate.hasUpdates()) {
  <div class="system-updates-panel">
    <h4 class="system-updates-title">{{ systemUpdate.title }}</h4>
    <app-system-updates-list></app-system-updates-list>
  </div>
}
